module.exports = __webpack_public_path__ + "2696e6fb3416e29eba42681fb4568ddb.pdf";